import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppVersionService {
  private readonly http = inject(HttpClient);

  readonly appVersion = toSignal(
    this.http.get<{ version: string }>('/assets/version.json').pipe(
      map(res => res?.version ?? null),
      catchError(() => of(null))
    )
  );
}
